<template>
  <div id="user-license-edit">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab label="免許・資格" icon-pack="feather" icon="icon-award">
            <div class="tab-text">
              <div v-if="selectedLicenseCategory === licenseCategory.BOAT">
                <tab-edit-boat-license
                  ref="tabEditBoatLicense"
                  @closePopup="$emit('closePopup')"
                ></tab-edit-boat-license>
              </div>
              <div v-if="selectedLicenseCategory === licenseCategory.MARINE">
                <tab-edit-marine-license
                  ref="tabEditMarineLicense"
                  @closePopup="$emit('closePopup')"
                ></tab-edit-marine-license>
              </div>
              <div v-if="selectedLicenseCategory === licenseCategory.OTHERS">
                <tab-edit-others-license
                  ref="tabEditOthersLicense"
                  @closePopup="$emit('closePopup')"
                ></tab-edit-others-license>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import TabEditBoatLicense from "./tabs/tabEditBoatLicense";
import TabEditMarineLicense from "./tabs/tabEditMarineLicense";
import TabEditOthersLicense from "./tabs/tabEditOthersLicense";
import LicenseMixin from "@/mixins/LicenseMixin";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "enterpriseLicenseEdit"
);

export default {
  components: {
    TabEditBoatLicense,
    TabEditMarineLicense,
    TabEditOthersLicense
  },
  mixins: [LicenseMixin],
  props: {
    payload: { type: Object },
  },
  data() {
    return {
      hasChangeImage: false
    };
  },
  computed: {
    ...mapState({
      inputForm: state => state.inputForm,
      selectedLicenseCategory: state => state.selectedLicenseCategory
    })
  },
  methods: {
    ...mapActions([
      "setCurrentLicenseData",
      "setSelectedLicenseCategory",
      "saveLicense",
      "resetLicenseEditState"
    ]),

    openDeleteConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "画像の削除",
        text: this.licenseData.name + "の画像を削除しますか？",
        acceptText: "削除する",
        cancelText: "キャンセル",
        accept: this.callDisassociateLicensePictureApi
      });
    },

    notificationDeleteImage() {
      if (this.isBoatLicense(this.licenseData.license_type_id)) {
        this.$refs.tabEditBoatLicense.deleteImage();
      } else if (this.isMarineLicense(this.licenseData.license_type_id)) {
        this.$refs.tabEditMarineLicense.deleteImage();
      } else {
        this.$refs.tabEditOthersLicense.deleteImage();
      }
    },

    notificationChangeEditMode() {
      if (this.isBoatLicense(this.licenseData.license_type_id)) {
        this.$refs.tabEditBoatLicense.changeEditMode(true);
      } else if (this.isMarineLicense(this.licenseData.license_type_id)) {
        this.$refs.tabEditMarineLicense.changeEditMode(true);
      } else {
        this.$refs.tabEditOthersLicense.changeEditMode(true);
      }
    },

    cleanup() {
      this.resetLicenseEditState();
    },

  },
  watch: {
    payload() {
      if ( this.payload && this.payload.license ) {
        this.setCurrentLicenseData(this.payload);
        let category = this.getLicenseCategoryById(
          this.payload.license.licenseTypeId.value
        );
        this.setSelectedLicenseCategory(category);
      }
    },
  },
  created() {
  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>

<style lang="scss">
.vs-button {
  .text-small {
    font-size: small;
  }
}

.text-font-bolder {
  font-weight: bolder;
}

.v-select-license-add {
  .vs__selected {
    padding: 0.24rem 0.24rem 0.24rem 0.62rem !important;
  }
  .vs__search {
    padding: 0.24rem 0.24rem 0.24rem 0.62rem !important;
  }
}

.vs__dropdown-toggle {
  border-radius: 5px;
}
</style>
